import { PaymentType, CardBrand, ProductType, TransactionStatus } from '@ace-clublabs/payment-types';
import { BrokerRegion, MembershipLevel } from '@lib/types';

export type ClubCodePhoneNumber = { [clubCode: string]: string };

export enum PolicyType {
  Membership = 'Membership',
  Auto = 'Auto',
  PersonalAuto = 'PersonalAuto',
  Home = 'Home',
  Homeowners = 'Homeowners',
  Classic = 'Classic',
  Condo = 'Condo',
  Tenant = 'Tenant',
  Rental = 'Rental',
  Watercraft = 'Watercraft',
  Umbrella = 'Umbrella',
  Earthquake = 'Earthquake',
}

export enum PolicyTitle {
  Membership = 'Membership',
  Auto = 'Auto',
  Home = 'Home',
  Classic = 'Collector car',
  Condo = 'Condo',
  Tenant = 'Tenant',
  Rental = 'Rental dwelling property',
  Watercraft = 'Watercraft',
  Umbrella = 'Personal umbrella',
  Earthquake = 'CA earthquake authority',
}

export enum Status {
  Declined = 'Card declined',
  Expired = 'Card expired',
  ExpiringSoon = 'Expiring soon',
  Updated = 'Payment updated',
}

export type StoredPayment = {
  storePaymentId: string;
  paymentType: PaymentType;
  cardBrand?: CardBrand;
  last4: string;
  disabled?: boolean;
};

export type PaymentOption = {
  id: string | number;
  value: string | number;
  display: any;
  header?: string;
};

export type ProcessPaymentProduct = {
  productId: string;
  productType: ProductType;
};

export interface IGetAutoPayDetailsRequest {
  transactionId?: string;
  brokerRegion?: BrokerRegion;
}

export interface IGetAutoPayDetailsResponse {
  policies: IInsuranceProduct[];
  emailOnFile: boolean;
  membership?: IMembershipProduct | { [key: string]: any };
}

export interface IInsuranceProduct {
  policyType: PolicyType;
  productId: string;
  dueDate: string;
  minDue: number;
  hasPIT: boolean;
  autoPay: AutoPay;
}

export interface IMembershipProduct {
  policyType: PolicyType;
  productId: string;
  benefitLevel: string;
  dueDate: string;
  minDue: number;
  hasPIT: boolean;
  autoPay: AutoPay;
  billPlan?: string;
  inRenewal?: boolean;
}

export type AutoPay = {
  offline: boolean;
  autoPayAllowed: boolean;
  enrolled: boolean;
  eligible: boolean;
  paymentDetails?: PaymentDetails;
};

export interface PaymentDetails {
  last4?: string;
  accountLast4?: string;
  paymentType: PaymentType;
  brand?: string;
  status?: string;
}

export enum ErrorType {
  SYSTEM_ERROR = 'SYSTEM_ERROR',
  GW_AUTOPAY_INELIGIBLE_ERROR = 'GW_AUTOPAY_INELIGIBLE_ERROR',
  PROCESSING_ERROR = 'PROCESSING_ERROR',
  AUTOPAY_ERROR = 'AUTOPAY_ERROR',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  AUTH_ERROR = 'AUTH_ERROR',
  SESSION_TIMEOUT = 'SESSION_TIMEOUT',
  UNAUTHORIZED = 'UNAUTHORIZED',
  MEMBERSHIP_PIT_ERROR = 'MEMBERSHIP_PIT_ERROR',
}

export type IGetDiscountRequest = {
  membershipNumber?: string;
  brokerRegion?: BrokerRegion;
  benefitLevel?: string;
  inArrears?: boolean;
};
export type IGetDiscountResponse = { discount: number };

export interface ICreateManifestRequest {
  productId: string;
  productType: ProductType;
  newEnroll: boolean;
  memcid?: string;
  storedPaymentAlertText?: string;
  brokerRegion?: BrokerRegion;
  tags?: any;
}
export interface ICreateManifestResponse {
  manifestId: string;
}

export interface IStoredPayment {
  id: string;
  paymentType: PaymentType;
  brand?: CardBrand;
  expiryDate?: string;
  isExpired?: boolean;
  last4?: string;
  accountLast4?: string;
  routingNumber?: string;
}

export interface IConfirmationApiRequest {
  transactionId: string;
  isTransactionCheck: boolean;
  productType: ProductType;
  productId: string;
  email?: string;
  memcid?: string;
}
export interface IConfirmationApiResponse {
  email?: string;
  firstName?: string;
  confirmationNumber?: string;
  autoPayConfirmationNumber?: string;
  productId: string;
  membershipNumber?: string;
  clubCode: string;
  isMembershipInBlackoutPeriod: boolean;
  paymentDetails?: {
    amountPaid: number;
    paymentStatus?: TransactionStatus;
    autoPayStatus?: TransactionStatus;
    storePaymentStatus?: TransactionStatus;
    paymentType: PaymentType;
    card?: {
      brand: string;
      last4: string;
    };
    echeck?: {
      accountLast4: string;
      routingNumber: string;
    };
  };
}

export interface ICancelMembershipAutoPayApiRequest {
  productId: string;
  benefitLevel: string;
  clubCode: string;
  brokerRegion?: BrokerRegion;
}

export interface ICancelMembershipAutoPayApiResponse {
  result: string;
}

export interface ICardBrandMap {
  [key: string]: string;
  visa: 'Visa';
  mastercard: 'MasterCard';
  discover: 'Discover';
  'american-express': 'American Express';
}
